export default {
  permanent: 'Регулярные работы',
  one: 'Временные работы'
}
